(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Prevent menu links from being intercepted by cart drawer handlers
  // Use capture phase on document to catch ALL clicks before other handlers
  (function() {
    // Run immediately and also on DOMContentLoaded to catch dynamically added links
    function setupMenuLinkProtection() {
      const menuLinks = document.querySelectorAll('.header__inline-menu a.header__menu-item');
      menuLinks.forEach(function(menuLink) {
        // Skip if already protected
        if (menuLink.hasAttribute('data-menu-link-protected')) return;
        menuLink.setAttribute('data-menu-link-protected', 'true');
        
        // Add click handler in capture phase to run before cart drawer handler
        menuLink.addEventListener('click', function(e) {
          // Check if this is NOT the cart icon
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon && menuLink !== cartIcon && !cartIcon.contains(menuLink)) {
            // This is a menu link - ensure normal navigation
            // Stop propagation to prevent cart drawer from intercepting
            e.stopImmediatePropagation();
            // Don't prevent default - let the link navigate normally
            return true;
          }
        }, true); // Capture phase - runs before other handlers
      });
    }
    
    // Run immediately
    setupMenuLinkProtection();
    
    // Also run on DOMContentLoaded in case links are added dynamically
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupMenuLinkProtection);
    } else {
      // DOM already loaded, run after a short delay to ensure cart drawer is initialized
      setTimeout(setupMenuLinkProtection, 100);
    }
    
    // Also watch for new menu links being added
    const observer = new MutationObserver(function(mutations) {
      setupMenuLinkProtection();
    });
    observer.observe(document.querySelector('.header__inline-menu') || document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
